export const gitCommit = '92e55c07'
